module.exports = __webpack_public_path__ + "static/img/アセット 81@3x.a01a099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 81@3x.png
// module id = /LTx
// module chunks = 1